import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import Swal from "sweetalert2";
import {
  getApiBaseUrl,
  // GET_BLOCKS,
  ADD_ACTIVITY,
} from "../../Config/Config";

const { Option } = Select;

const AddDryerEquip = () => {
  const [blockOptions, setBlockOptions] = useState([]);
  const [formData, setFormData] = useState({
    Name: "", // Changed from EquipmentName to Name
    EquipmentId: "", // Changed from SerialNumber to EquipmentId
  });
  console.log(formData);
  const [loading, setLoading] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const user = JSON.parse(sessionStorage.getItem("user"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchBlocks = async () => {
    try {
      // const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      const response = await fetch(
        `${getApiBaseUrl()}/api/getlocationsforPresures`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      const blocks = result?.ResultData || [];
      setBlockOptions(blocks);
    } catch (err) {
      console.error("Failed to fetch blocks:", err);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const handleBlockChange = (value) => {
    setSelectedBlock(value);
    setFormData((prev) => ({
      ...prev,
      BlockId: value,
    }));
  };

  const addActivity = async (isSuccess, message) => {
    const activityPayload = {
      ActivityType: 1,
      PerformedBy: user?.UserID,
      PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
      Notes: message,
      Location: "Equipment",
      IsSucces: isSuccess ? 1 : 0,
    };

    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
    } catch (error) {
      console.error("Activity logging failed:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      CreatedBy: user?.UserID,
      Name: formData.Name,
      BlockId: selectedBlock,
      EquipmentId: formData.EquipmentId,
    };

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/addPressure`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      setLoading(false);

      if (result?.Status) {
        await addActivity(true, `Added New Equipment: ${formData.Name}`);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Equipment added successfully!",
        }).then(() => {
          window.location.reload();
        });
      } else {
        await addActivity(
          false,
          `Failed to Add New Equipment: ${formData.Name}`
        );

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Equipment could not be added.",
        });
      }
    } catch (error) {
      setLoading(false);
      await addActivity(false, `Failed to Add New Equipment: ${formData.Name}`);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while submitting the form.",
      });
    }
  };

  const clearData = () => {
    setFormData({ Name: "", EquipmentId: "" });
    setSelectedBlock(null);
  };

  useEffect(() => {
    const offcanvas = document.getElementById("AddDryerEquipOffcanvas");
    if (offcanvas) {
      const handleClose = () => {
        clearData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="AddDryerEquipOffcanvas"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title me-4">Add Equipment</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label className="form-label">Equipment Name</label>
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                name="Name"
                placeholder="Enter Equipment Name"
                value={formData.Name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Equipment ID</label>
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                name="EquipmentId"
                placeholder="Enter Equipment ID"
                value={formData.EquipmentId}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3 w-100">
              <label className="form-label">Block</label>
              <span className="text-danger ms-1">*</span>
              <Select
                showSearch
                placeholder="Select a Block"
                optionFilterProp="children"
                onChange={handleBlockChange}
                value={selectedBlock}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                aria-required
              >
                {blockOptions.map((block) => (
                  <Option key={block.BlockId} value={block.BlockId}>
                    {block.BlockName}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddDryerEquip;
